export enum ListItemClickAction {
  ADD_TO_BOOKMARKS = 'add_to_bookmarks',
  TOGGLE_DETAIL = 'toggle_detail',
  EXPORT_CITATION = 'export_citation',
  EXTERNAL_LINK = 'external_link',
  READING_INTENTION = 'reading_intention',
  PERSONAL_NOTE = 'personal_note',
  SHOW_SHARE_ITEM = 'show_share_item',
}
